import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ReportListSlice = createSlice({
  name: "ReportListSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ReportList: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successReportList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureReportList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearReportList: (state) => {
      state.data = {};
    },
  },
});

export const {
  ReportList,
  failureReportList,
  successReportList,
  clearReportList,
} = ReportListSlice.actions;

export default ReportListSlice.reducer;
